import {FC} from "react";
import {useTranslation} from "react-i18next";
import {SimpleTable} from "@interstate/components/SimpleTable";
import {OrganizationAddressInput} from "@common-core/coat-operational-hierarchy-appsync-model";
import {TabRow} from "../../../../../tab-content";
import {Nullable} from "../../../../../utils";
import {AddressTableBody} from "../../../../overview/AddressTableBody";

export interface AddressRowProps {
  address?: Nullable<OrganizationAddressInput>;
}

export const AddressRow: FC<AddressRowProps> = ({address}) => {
  const {t} = useTranslation();
  return (
    <TabRow
      name={"address"}
      header={<h4>{t("entity-detail.dealer.address.details")}</h4>}>
      <SimpleTable
        id={"address-table"}
        data-testid={"address-table"}
        dataDensity={"small"}
        background={"white"}
        className={"address-table"}
        bordered={false}
        hover={false}
        striped={false}>
        <AddressTableBody
          streetAddressLine1={address?.streetAddressLine1}
          streetAddressLine2={address?.streetAddressLine2}
          city={address?.city}
          state={address?.state}
          country={address?.country}
          zip={address?.zip}
        />
      </SimpleTable>
    </TabRow>
  );
};
